export class ResetPasswordModel{
    password: string;
    userName: string;
    companyId: string;
   
    constructor(){
        this.password = "";
        this.userName="";
        this.companyId= "";
    }
}